export default {
  namespaced: true,

  state: {
    backgroundColor: 'white',
  },

  getters: {
    getBackgroundColor: state => state.backgroundColor,
  },

  actions: {
    setSuccessBackground({ state }) {
      state.backgroundColor = '#ecfff1';
    },

    resetBackground({ state }) {
      state.backgroundColor = 'white';
    },
  },
};
